/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/

import axios from "axios";
import updateHeaderInterceptor from "./updateHeaderInterceptor";

function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

const httpClient = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,    
    headers: {
        "Content-type": "application/json",
        // "X-CSRF-TOKEN": getCookie('CSRF-TOKEN')
    }
});

// global unauthorized check
httpClient.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 401) {
            window.location.href = "/";
            localStorage.setItem('isLoggedIn', false);
            localStorage.removeItem('token');   // removeItem avoids storing the string "null" which is truthy
            localStorage.setItem('currentPartnerId', "-1");
            localStorage.setItem('currentCustomerId', "-1");
            localStorage.setItem('username', null);
            localStorage.setItem('userId', null);
            localStorage.setItem('roles', JSON.stringify([]));
            localStorage.setItem('loggedInCustomerOrganization', "");
            localStorage.setItem('isPartnerAdmin', false);
            localStorage.setItem('isPortalAdmin', false);
            localStorage.setItem('isCustomerSupport', false);
            localStorage.setItem('logo', null);
            localStorage.setItem('firstName', null);
            localStorage.setItem('lastName', null);
            localStorage.setItem('email', null);
            localStorage.setItem('picture', null);
            localStorage.setItem('faveAssetPath', JSON.stringify([]));
            localStorage.setItem('activePath', "/");
            localStorage.setItem('favoriteCustomers', JSON.stringify([]));
            localStorage.setItem('favoriteAssets', JSON.stringify([]));
        }
        return Promise.reject(error);
    }
);

updateHeaderInterceptor(httpClient);

export default httpClient;
//"https://support-lifewhere.azurewebsites.net/",//"https://qa-support-lifewhere.azurewebsites.net/",//"https://dev-supportweb.azurewebsites.net/",//https://localhost:5003